import { X } from 'lucide-react';
import { useEffect } from 'react';
import { useI18nStore } from '../../shared/i18n/i18nStore';

export type BannerView = {
  id: string;
  round: number;
  kind: 'result' | 'settling' | 'credited' | 'corrected';
  text: string;
  tone: 'neutral' | 'gold';
  canOpen: boolean;
  ms: number;
};

/** One line at the top of the room; auto-dismisses; "View" opens the settled card without an auto-close. */
export function RoundResultBanner({ banner, onOpen, onDismiss }: { banner: BannerView; onOpen: () => void; onDismiss: () => void }) {
  const t = useI18nStore((state) => state.t);
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, banner.ms);
    return () => window.clearTimeout(timer);
    // Keyed on the banner instance, not on the parent's inline callback.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [banner.id, banner.ms]);
  return (
    <div className="rr-banner" role="status" aria-live="polite" data-round-result-banner="true" data-kind={banner.kind} data-tone={banner.tone} data-round={banner.round}>
      <span>{banner.text}</span>
      {banner.canOpen ? <button type="button" onClick={onOpen}>{t('bannerView')}</button> : <span />}
      <button className="rr-banner-x" type="button" onClick={onDismiss} aria-label={t('close')}>
        <X size={14} aria-hidden="true" />
      </button>
    </div>
  );
}
